var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mu-drawer",class:{'open': _vm.open, 'right': _vm.right},style:(_vm.drawerStyle)},[_c('div',{staticClass:"mu-paper",class:_vm.paperClass},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"mu-all",style:(_vm.display),on:{"click":_vm.handleClose}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9bfdb30","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/drawer/drawer.vue
// module id = null
// module chunks = 